import moment from "moment";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { AideEnLigneDto } from "../../dto/GenApi.iNotPaie.Dto/AideEnLigneDto";
import { EtatSaisie } from "../../dto/GenApi.iNotPaie.Dto/EtatSaisie";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { HeaderDto } from "../../dto/GenApi.iNotPaie.Dto/headerDto";
import { SocieteDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { TraitementEnCoursEnum } from "../../dto/GenApi.iNotPaie.Dto/TraitementEnCoursEnum";
import { tabItem } from "../../models/tabItem";
import { License } from "../../shared/Enums/Licensing/License";
import { TypePageErreur } from "../../shared/models/typePageErreur";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { LicensingManagerInstance } from "../Controls/LicensingManager";
import iNotPaieStorageKeys, { LocalStorageService } from "../Controls/LocalStorageService";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ServiceEnqueteDeSatisfactionInstance } from "../enqueteDeSatisfaction/service";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";

@Component
export default class ContextComponent extends Vue {

    readonly urlFoederisDefault: string = 'https://www.foederis.fr/';

    @Prop()
    public tabItems: tabItem[] = [];

    // Aide en ligne
    public aideEnLigne: AideEnLigneDto[] = [];

    @Prop()
    public activeMenu = false;

    public dataReady = false;
    public isSingleSociete = true;
    public societeActive?: SocieteDto = undefined;
    public listeSocietes: SocieteDto[] = [];
    public codeSocieteActive?: string = "";
    public isMenuAllowed?: boolean = false;
    public displayBouttonSaisie = false;
    public viewPanelApp = false;
    public viewPanelNotif = false;
    public viewPanelProfil = false;
    public activePanelNotif = true;
    public haveNewNotification = false;
    public enableAppPanel = false;
    public isValiderSaisieDisabled = false;
    public isPst = false;
    public isCommunityVisible = false;
    public isVersionVisible = false;
    public isChatbotVisible = false;

    @Prop()
    public traitementEnCours = false;

    public onSocieteActiveChanged(): void {
        if (ParametresInstance.societeCourante != undefined && this.codeSocieteActive == ParametresInstance.societeCourante.Code) {
            return;
        }
        if (this.tabItems.length > 1) {
            this.demanderConfirmationChangementSociete();
        } else {
            this.appliquerChangementSociete();
        }
    }

    public demanderConfirmationChangementSociete(): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Attention, le changement de société va fermer tous les onglets ouverts, et les saisies en cours éventuelles seront perdues. Souhaitez-vous vraiment continuer ?",
            showDialog: true,
            callBackYes: () => {
                this.appliquerChangementSociete();
            },
            callBackNo: () => {
                this.codeSocieteActive = ParametresInstance.societeCourante != undefined ? ParametresInstance.societeCourante.Code : "";
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public appliquerChangementSociete(): void {
        const societe = this.header.Societes.filter(s => s.Code == this.codeSocieteActive)[0];
        if (societe.NoIcare != undefined) {
            LocalStorageService.set(iNotPaieStorageKeys.ICARE, societe.NoIcare.toString());
            if (societe.Code != undefined) {
                LocalStorageService.set(iNotPaieStorageKeys.USER_SOCIETE, societe.Code);
            }
            ServicesFactoryInstance.AuthenticationService.redirectToSSO(location.origin, societe.NoIcare.toString());
        } else {
            this.closeTabs();
        }
    }

    public closeTabs(): void {
        this.societeActive = this.header.Societes.filter(s => s.Code == this.codeSocieteActive)[0];
        ParametresInstance.setSocieteCourante(this.societeActive);
        if (this.tabItems[0] != undefined) {
            EventBus.NavigateTo(this.tabItems[0].route);
        }
    }

    public header: HeaderDto = {
        Societes: [],
        IsPst: false,
        Utilisateur: {
            Id: 0,
            EstValideurConges: false,
            Intitule: "",
            ProfilUtilisateur: {
                Favoris: [],
                ListeSalarieConfiguration: {
                    DateDebutContratVisible: true,
                    DateDebutTransfertVisible: true,
                    DateDepartVisible: true,
                    DateEntreeVisible: true,
                    DateFinContratVisible: true,
                    ListeSalarieModeTuile: false,
                    NomNaissanceVisible: true,
                    QualificationVisible: true,
                    RegimeVisible: true,
                    TypeContratVisible: true,
                    BulletinParMailVisible: false,
                    CongesVisible: false,
                    ConventionCollectiveVisible: false,
                    ModeReglementVisible: false,
                    MutuelleVisible: false,
                    NatureContratVisible: false,
                    RemunerationVisible: false,
                    ResponsableHierarchiqueVisible: false,
                    TempsTravailVisible: false,
                    LibelleEmploiVisible: true,
                    DateFinPeriodeEssaiVisible: false,
                    DateFinPrevisionnelleCddVisible: false,
                    DateEntreeProfessionVisible: false,
                    ServiceVisible: false,
                    DateNaissanceVisible: false
                },
                SaisieVariablesConfiguration: { ModeSalarieHaut: false }
            }
        }
    };

    public mounted(): void {

        EventBus.$on(EventConstants.OPEN_AIDE_EN_LIGNE, () => {
            this.openLink();
        });

        EventBus.$on(EventConstants.CHANGE_VALIDER_SAISIE_STATE, disable => {
            this.isValiderSaisieDisabled = disable;
        });

        // Affichage conditionnel dans menu utilisateur
        EventBus.$on(EventConstants.LICENSES_LOADED, this.onLicensesLoaded);

        this.setIsVersionVisible();

        ServicesFactoryInstance.HeaderService.getHeaderInfos(data => {
            this.isPst = data.IsPst;

            ParametresInstance.setPstStatus(this.isPst);
            ParametresInstance.setEnvType(data.EnvType);
            ParametresInstance.setMailPST(data.EMailPst);
            ParametresInstance.setUtilisateurCourant(data.Utilisateur);

            this.header = data;
            this.listeSocietes = this.header.Societes;

            if (!ParametresInstance.userHasRole(RoleConstants.Administrateur)
                && !ParametresInstance.userHasRole(RoleConstants.AdministrateurPST)
                && !ParametresInstance.userHasRole(RoleConstants.UtilisateurPST)
                && !ParametresInstance.userHasRole(RoleConstants.Payeur)
                && ParametresInstance.userHasRole(RoleConstants.Salarie)
                && ParametresInstance.utilisateurCourant?.IdSalarie != undefined) {
                ServicesFactoryInstance.SocieteService.getSocietesActivesOfSalarieConnecte(data => {
                    this.listeSocietes = data;
                    this.initData();
                });
            } else {
                this.initData();
            }
        });
    }

    public getDatePeriodeActive(): string {
        let dateString: string = "";
        if (this.societeActive == undefined || this.societeActive.PeriodeActive == undefined) {
            dateString = "Aucune période";
        } else {
            dateString = moment.utc(this.societeActive?.PeriodeActive).format("MMMM YYYY");
            dateString = dateString.charAt(0).toUpperCase() + dateString.slice(1);
        }

        return dateString;
    }

    public getEtatSaisieLibelle(): string | void {
        if (this.societeActive != undefined) {
            switch (this.societeActive.EtatSaisie) {
                case undefined:
                    return "";
                case 1:
                    return "Saisie en cours";
                case 2:
                    return "Saisie soumise à la PST";
                case 3:
                    return "Saisie validée par la PST";
                case 4:
                    return this.isPst ? "Traitée par la PST" : "Saisie clôturée";
            }
        }
    }

    public onSoumettre(): void {
        ServiceEnqueteDeSatisfactionInstance.enqueteDeSatisfaction(this.soumettre);
    }

    public soumettre(): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment valider l'ensemble des éléments variables du mois pour traitement ? Vous ne pourrez plus les modifier",
            callBackYes: () => {
                ServicesFactoryInstance.PstService.SoumettreSaisie(etat => {
                    if (this.societeActive != undefined) {
                        this.societeActive.EtatSaisie = etat;
                        if (ParametresInstance.societeCourante != undefined) {
                            EventBus.$emit(EventConstants.ETAT_SAISIE_CHANGED, etat);
                            this.$forceUpdate();
                        }
                    }
                });
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public sendMail(): void {
        this.closePanelHeader();
        window.location.href = "mailto: " + ParametresInstance.eMailPST;
    }

    public valider(isTraitement: boolean): void {
        let message = "Souhaitez-vous vraiment valider la saisie ? Vous ne pourrez plus la modifier.";
        if (isTraitement) {
            message = "Vous allez retraiter la paie de cette étude. Êtes-vous sûr ?";
        }
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message,
            callBackYes: () => {
                this.isValiderSaisieDisabled = true;
                EventBus.$emit("TraitementEnCoursDto", {
                    Action: TraitementEnCoursEnum.ValiderSaisie,
                    Description: "Un traitement est en cours"
                });
                ServicesFactoryInstance.PstService.ValiderSaisie(etat => {
                    if (this.societeActive != undefined) {
                        this.societeActive.EtatSaisie = etat;
                        if (ParametresInstance.societeCourante != undefined) {
                            EventBus.$emit(EventConstants.ETAT_SAISIE_CHANGED, etat);
                            this.$forceUpdate();
                        }
                    }
                });
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public setDisplayButton(): boolean {
        return this.societeActive != undefined && this.societeActive.IsPaieActive && this.societeActive.EtatSaisie === EtatSaisie.SaisieEnCours && this.isPst && ParametresInstance.userIsAuthorized([RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]);
    }

    public setDisplayButtonValider(): boolean {
        return this.societeActive != undefined && this.societeActive.IsPaieActive && this.societeActive.EtatSaisie === EtatSaisie.SaisieValideeParSociete && this.isPst && ParametresInstance.userIsAuthorized([RoleConstants.AdministrateurPST]);
    }

    public setDisplayButtonRetraitement(): boolean {
        return this.societeActive != undefined && this.societeActive.IsPaieActive && this.societeActive.EtatSaisie === EtatSaisie.SaisieCloturee && this.isPst && ParametresInstance.userIsAuthorized([RoleConstants.AdministrateurPST]);
    }

    public toggleStateModeMenu(): void {
        this.$emit("toggleMenu", "");
    }

    public isPath(path: string): boolean {
        return this.$router.currentRoute.path == path;
    }

    public navigateTo(path: string): void {
        this.$emit("navigateTo", path);
    }

    public closeTab(path: string): void {
        this.$emit("closeTab", path);
    }

    public getTabWidth(item: any): any {
        if (item.titre == "") {
            return {
                width: "47px"
            };
        }

        const maxWidth = 250;
        const minWidth = 40;
        const tabItems: any = this.$refs.tabItems;
        if (tabItems != undefined && tabItems.clientWidth != undefined) {
            let hauteurEchelle = (Number(tabItems.clientWidth) - 120) / (this.tabItems.length - 1);

            hauteurEchelle = hauteurEchelle > maxWidth ? maxWidth : hauteurEchelle;
            hauteurEchelle = hauteurEchelle < minWidth ? minWidth : hauteurEchelle;

            return {
                width: hauteurEchelle + "px"
            };
        } else {
            return {};
        }
    }

    public logout(): void {
        ServicesFactoryInstance.AuthenticationService.logout();
    }

    public openLink(): void {
        this.closePanelHeader();

        ServicesFactoryInstance.AideEnLigneService.getAideEnLigneUrl(url => {
            if (url !== undefined && url.trim() !== "") {
                window.open(url.trim(), "_blank")
            } else {
                NotificationServiceInstance.SendFailed("Erreur dans l'ouverture de l'aide en ligne.");
                return;
            }
        }, () => {
            NotificationServiceInstance.SendFailed("Erreur dans l'ouverture de l'aide en ligne.");
            return;
        });
    }

    /**
     * Ouvre la page d'Inwink
     */
    public openLinkInwink(): void {
        this.closePanelHeader();

        ServicesFactoryInstance.AideEnLigneService.getCommunityUrl(url => {
            if (url !== undefined && url.trim() !== "") {
                window.open(url.trim(), "_blank")
            } else {
                NotificationServiceInstance.SendFailed("L'url d'Inwink est vide ou mal paramétrée.");
                return;
            }
        }, () => {
            NotificationServiceInstance.SendFailed("Erreur dans l'ouverture d'Inwink.");
            return;
        });
    }

    /**
     * Ouvre la page du Chatbot Ideta
     */
    public openLinkChatbot(): void {
        this.closePanelHeader();

        ServicesFactoryInstance.AideEnLigneService.getChatbotUrl(url => {
            if (url !== undefined && url.trim() !== "") {
                window.open(url.trim(), "_blank");
            } else {
                NotificationServiceInstance.SendFailed("L'url du chatbot est vide ou mal paramétrée.");
                return;
            }
        });
    }

    private initData(): void {
        if (!this.checkErrorPage()) {
            return;
        }

        // Numéro icare lié à notre token
        const iCareStorage = LocalStorageService.get(iNotPaieStorageKeys.ICARE);
        const codeSocieteStored = LocalStorageService.get(iNotPaieStorageKeys.USER_SOCIETE);

        const listeSocietesIcare = this.listeSocietes.filter(s => s.NoIcare != undefined && s.NoIcare.toString() == iCareStorage);
        const listeSocietesCodeSociete = this.listeSocietes.filter(s => s.Code != undefined && s.Code == codeSocieteStored);
        const listeSocietesIcareAndCode = listeSocietesIcare.filter(s => s.Code != undefined && s.Code == codeSocieteStored);

        if (iCareStorage != undefined && codeSocieteStored != undefined && listeSocietesIcareAndCode.length > 0) {
            // On retrouve la société avec le combo numéro icare lié au token et code société sélectionné
            this.societeActive = listeSocietesIcareAndCode[0];
        }
        else if (iCareStorage != undefined && listeSocietesIcare.length > 0) {
            // On prend la première société qui a un numéro icare lié au token de notre utilisateur
            this.societeActive = listeSocietesIcare[0];
        } else if (codeSocieteStored != undefined && listeSocietesCodeSociete.length > 0) {
            // On prend la première société qui correspond au code société stocké
            this.societeActive = listeSocietesCodeSociete[0];
        } else {
            this.societeActive = this.listeSocietes[0];
        }

        this.codeSocieteActive = this.societeActive.Code;
        this.isSingleSociete = this.listeSocietes == undefined || this.listeSocietes.length <= 1;
        this.isMenuAllowed = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]);
        this.societeActive = this.header.Societes.filter(s => s.Code == this.codeSocieteActive)[0];
        ParametresInstance.setSocieteCourante(this.societeActive);

        this.dataReady = true;

        // Aide en ligne
        ServicesFactoryInstance.AideEnLigneService.getAideEnLigne(data => {
            if (data != undefined) {
                this.aideEnLigne = data;
            }
        });

        this.$forceUpdate();
        this.$emit("isCompleted");
    }

    private checkErrorPage(): boolean {
        let isAuthorized = true;
        let typeError;

        // Aucun contrat actif dans une société
        if (this.listeSocietes === undefined || this.listeSocietes.length === 0) {
            isAuthorized = false;
            typeError = TypePageErreur.ListeSocietes;
        }

        // Aucun utilisateur associé au compte SSO
        if (this.header.Utilisateur.Roles?.length === 0 && this.header.Utilisateur.IdSalarie === null) {
            isAuthorized = false;
            typeError = TypePageErreur.SSO;
        }

        if (!isAuthorized) {
            this.$router.push({
                name: "Erreur",
                params: { id: typeError.toString() }
            });
            ParametresInstance.modeBloque = true;
            this.dataReady = true;
        }

        return isAuthorized;
    }

    //Ouvre un nouveau onglet sur l'url rattaché à la société foederis sinon sur l'url par défaut
    public openFoederisNewTab() {
        const urlFoederis: string | undefined = ParametresInstance.societeCourante?.UrlEntretienProfessionnel
        if (urlFoederis) {
            window.open(urlFoederis, '_blank');
        } else {
            window.open(this.urlFoederisDefault, '_blank');
        }
    }

    public togglePanelHeaderNotif(): void {
        this.viewPanelNotif = !this.viewPanelNotif;
        this.haveNewNotification = false;
    }

    public togglePanelHeaderProfil(): void {
        this.viewPanelProfil = !this.viewPanelProfil;
    }

    public closePanelHeader(): void {
        this.viewPanelApp = false;
        this.viewPanelNotif = false;
        this.viewPanelProfil = false;
    }

    public updateNewNotif(haveNewNotif: boolean): void {
        if (haveNewNotif) {
            this.haveNewNotification = true;
        }
    }

    public getInitial(): string {
        const split = this.getIntituleUtilisateur().split(" ");

        return (split[0][0] + "" + split[1][0]);
    }

    public getIntituleUtilisateur(): string {
        const fullName = this.header.Utilisateur.Intitule!.replace(/  +/g, " ");
        const split = fullName.split(" ");

        return this.ucFirst(split[0]) + " " + this.ucFirst(split[1]);
    }

    public ucFirst(test: string): string {
        if (test == null || test === "") {
            return "";
        }
        return test[0].toUpperCase() + test.slice(1);
    }

    public estModeBloque(): boolean {
        return ParametresInstance.modeBloque;
    }

    /**
     * Permet d'autoriser l'accès au simulateur
     * @returns true si l'utilisateur a le rôle Administrateur, AdministrateurPST ou UtilisateurPST
     */
    public authorizeSimulateur(): boolean {
        return ParametresInstance.userHasRole(RoleConstants.Administrateur)
            || ParametresInstance.userHasRole(RoleConstants.AdministrateurPST)
            || ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);
    }

    /**
     * Redirection vers le simulateur de la PST
     */
    public redirectionSimulateur(): void {
        window.open('https://simulateur-pst.netlify.app/', '_blank');
    }

    /**
     * Permet d'afficher la ligne "Communauté" dans le menu utilisateur
     */
    private onLicensesLoaded(): void {
        this.isCommunityVisible = LicensingManagerInstance.hasLicense(License.Inwink);
        this.isChatbotVisible = LicensingManagerInstance.hasLicense(License.Ideta);
    }

    /**
     * Permet d'afficher la ligne "Note de version" dans le menu utilisateur
     */
    private setIsVersionVisible(): void {
        this.isVersionVisible = FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.Jimo);
    }
}



// WEBPACK FOOTER //
// ./src/components/context/context.ts